<template>
  <div class="custom-dialog">
    <div class="v-model" @click="hide"></div>
    <div class="previewModal-wrapper">
    <div class="header">
      <div class="header-title">
        {{ title }}
      </div>
    </div>
    <div class="content">
      <div class="iframe-wrapper"><slot></slot></div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  watch: {
    visible(val) {
      if (val) {
        this.closed = false;
        this.$emit("open");
        this.$el.addEventListener("scroll", this.updatePopper);
        this.$nextTick(() => {
          this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener("scroll", this.updatePopper);
        if (!this.closed) this.$emit("close");
        if (this.destroyOnClose) {
          this.$nextTick(() => {
            this.key++;
          });
        }
      }
    },
  },

  props: {
    title: {
        type: String,
        default: ''
      },

      modal: {
        type: Boolean,
        default: true
      },

      modalAppendToBody: {
        type: Boolean,
        default: true
      },

      appendToBody: {
        type: Boolean,
        default: false
      },

      lockScroll: {
        type: Boolean,
        default: true
      },

      closeOnClickModal: {
        type: Boolean,
        default: true
      },

      closeOnPressEscape: {
        type: Boolean,
        default: true
      },

      showClose: {
        type: Boolean,
        default: true
      },

      width: String,

      fullscreen: Boolean,

      customClass: {
        type: String,
        default: ''
      },

      top: {
        type: String,
        default: '15vh'
      },
      beforeClose: Function,
      center: {
        type: Boolean,
        default: false
      },

      destroyOnClose: Boolean
  },

  methods: {
      getMigratingConfig() {
        return {
          props: {
            'size': 'size is removed.'
          }
        };
      },
      handleWrapperClick() {
        if (!this.closeOnClickModal) return;
        this.handleClose();
      },
      handleClose() {
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.hide);
        } else {
          this.hide();
        }
      },
      hide(cancel) {
        if (cancel !== false) {
          this.$emit('update:visible', false);
          this.$emit('close');
          this.closed = true;
        }
      },
      updatePopper() {
        this.broadcast('ElSelectDropdown', 'updatePopper');
        this.broadcast('ElDropdownMenu', 'updatePopper');
      },
      afterEnter() {
        this.$emit('opened');
      },
      afterLeave() {
        this.$emit('closed');
      }
    },

  mounted() {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);

      }
    }
  },

  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },
};
</script>

<style lang="scss" scoped>
.custom-dialog{
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2002;
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-model{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
}
.previewModal-wrapper {
  position: relative;
  width: 376px;
  height: 756px;
  max-height: calc(100vh - 20px);
  box-sizing: content-box;
  border: 2px solid #fff;
  z-index: 1001;
  background-color: #fff;
  box-shadow: -4px 2px 17px 0 rgba(0, 0, 0, 0.2);
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  pointer-events: all;
  border-radius: 40px;
  .header {
    position: relative;
    text-align: left;
    height: 88px;
    align-items: center;
    background: url(//sf1-scmcdn-tos.pstatp.com/goofy/cg_growth/resource/homed_pgc_platform/assets/headerCut.e5c552f9.png);
    background-size: auto 92px;
    background-position: -4px -4px;
    background-repeat: no-repeat;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    overflow: hidden;
    border-radius: 40px 40px 0 0;
    .header-title {
      text-align: center;
      width: 200px;
      height: 26px;
      background: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 9px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, STHeiti, Microsoft YaHei, Helvetica, Arial,
        sans-serif;
      font-weight: 600;
      color: #000;
      line-height: 26px;
    }
  }
  .content {
    flex: 1 1 0;
    overflow: hidden;
    height: 100%;
    border-radius: 0 0 40px 40px;
  }
  .iframe-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: 2px;
    overflow: hidden;
  }
}
</style>
